import 'bootstrap';
import '../Common/jmap';

// JMAP共通設定
import { JMAP_COMMON_SETTING } from '../Common/const';
// 拠点
import { JMAP_LOGIHUB_CONDITIONS } from '../Common/const';
import { JMAP_LOGIHUB_HTYPE } from '../Common/const';
import { JMAP_LOGIHUB_UNIT } from '../Common/const';
/**
 * =====================================================================================
 * jmap用
 * =====================================================================================
 */
$(function ()
{
    // 変数受取
    let $script = $('#LogihubMapScript');
    const speed = 200;

    //*********************************************************************************************
    // 定数定義（引数）
    //*********************************************************************************************
    //-----------------------------------------------------
    // 拠点
    //-----------------------------------------------------
    let logihub_receive_prefecture_codes = JSON.parse($script.attr('logihub_prefecture_codes'));
    let logihub_prefecture_codes = [];
    let logihub_keys = Object.keys(logihub_receive_prefecture_codes);
    logihub_keys.map((key) => {
        if (key !== '') {
            if (key !== "北海道") {
                logihub_receive_prefecture_codes[key].name = logihub_receive_prefecture_codes[key].name.slice(0, -1) ;
            }
            logihub_prefecture_codes.push(logihub_receive_prefecture_codes[key]);
        }
    });

    //=============================================================================================
    // メイン処理
    //=============================================================================================
    const main = () => {

        //-------------------------------------------------
        // 地図生成　：　拠点
        //-------------------------------------------------
        var jmap_logihub_obj = $.extend(JMAP_COMMON_SETTING, {
            heatmapConditions : JMAP_LOGIHUB_CONDITIONS,
            heatmapType       : JMAP_LOGIHUB_HTYPE,
            heatmapLabelUnit  : JMAP_LOGIHUB_UNIT,
            areas             : logihub_prefecture_codes,
            onSelect          : onSelectPrefectureLogihub,
        });
        $('#jmap-logihub').jmap(jmap_logihub_obj);

        //-------------------------------------------------
        // 拠点種別
        //-------------------------------------------------
        const base_type = $("[name='logihub[base_type]']").val();
        if (base_type === "2") {
            $("[name='logihub[is_core_logihub]']").prop("disabled", true);
        } else {
            $("[name='logihub[is_core_logihub]']").prop("disabled", false);
        }
    }

    const onSelectPrefectureLogihub = (e, data) => {
    }

    //=============================================================================================
    // 拠点種別変更時
    //=============================================================================================
    $("[name='logihub[base_type]']").on("change", function (e) {
        if (e.target.value === "2") {
            $("[name='logihub[is_core_logihub]']").prop("disabled", true);
        } else {
            $("[name='logihub[is_core_logihub]']").prop("disabled", false);
        }

        // 202401 hiromatsu 課題管理表 No.152 検索に「中核ロジ拠点」を追加する対応　中核ロジ拠点を選択時、自動的に中核拠点フラグを付ける
        if (e.target.value === "4") {
            $("[name='logihub[is_core_logihub]']").prop("checked", true);
        } else {
            $("[name='logihub[is_core_logihub]']").prop("checked", false);
        }
    })

    main();
});
